export default "__VITE_ASSET__Con92dzr__"